import { render, staticRenderFns } from "./documentPdf.vue?vue&type=template&id=3033cf85&"
import script from "./documentPdf.vue?vue&type=script&lang=js&"
export * from "./documentPdf.vue?vue&type=script&lang=js&"
import style0 from "./documentPdf.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports